"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { STATEMENT_META, STATEMENT_TYPE } from "@/helpers/Types";
import SocialStatementIcon from "@/components/user/utils/icons/SocialStatementIcon";
export default function UserPageIdentityAddStatementsContactInput(t0) {
  const $ = _c(21);
  const {
    activeType,
    value,
    onChange
  } = t0;
  const inputRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== activeType) {
    t2 = [activeType];
    $[1] = activeType;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== onChange) {
    t3 = event => {
      const {
        value: raw
      } = event.target;
      const nativeEvent = event.nativeEvent as {
        isComposing?: boolean;
      };
      const isComposing = Boolean(nativeEvent?.isComposing);
      onChange(isComposing ? raw : collapseProtocolPrefix(raw));
    };
    $[3] = onChange;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleInputChange = t3;
  const inputId = `statement-${activeType}`;
  const t4 = STATEMENT_META[activeType];
  let t5;
  if ($[5] !== inputId || $[6] !== t4.title) {
    t5 = <label htmlFor={inputId} className="tw-block tw-text-sm tw-font-normal tw-leading-5 tw-text-iron-200">{t4.title}</label>;
    $[5] = inputId;
    $[6] = t4.title;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== activeType) {
    t6 = <div className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3"><div className="tw-h-5 tw-w-5 tw-flex tw-items-center tw-flex-shrink-0"><SocialStatementIcon statementType={activeType} /></div></div>;
    $[8] = activeType;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = STATEMENT_META[activeType];
  let t8;
  if ($[10] !== handleInputChange || $[11] !== inputId || $[12] !== t7.inputPlaceholder || $[13] !== value) {
    t8 = <input id={inputId} ref={inputRef} type="text" required={true} autoComplete="off" value={value} onChange={handleInputChange} placeholder={t7.inputPlaceholder} className="tw-form-input tw-appearance-none tw-block tw-w-full tw-rounded-lg tw-border tw-border-solid tw-border-iron-800 tw-py-3 tw-pl-11 tw-pr-3 tw-bg-iron-900 focus:tw-bg-iron-950 tw-text-iron-100 tw-font-normal tw-caret-primary-400 tw-shadow-sm hover:tw-ring-iron-700 placeholder:tw-text-iron-400 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-iron-700 tw-text-base sm:tw-leading-6 tw-transition tw-duration-300 tw-ease-out" />;
    $[10] = handleInputChange;
    $[11] = inputId;
    $[12] = t7.inputPlaceholder;
    $[13] = value;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t8) {
    t9 = <div className="tw-relative tw-mt-1.5">{t6}{t8}</div>;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t5 || $[19] !== t9) {
    t10 = <>{t5}{t9}</>;
    $[18] = t5;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}
const COLLAPSE_PROTOCOL_PREFIX = /^(?:(https?):\/\/)+/i;
const collapseProtocolPrefix = (value: string): string => value.replace(COLLAPSE_PROTOCOL_PREFIX, (_match, scheme: string) => `${scheme.toLowerCase()}://`);